var React = require('react');

function Zap (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"13 2 3 14 12 14 11 22 21 10 12 10 13 2"}));
}

Zap.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-zap"};

module.exports = Zap;

Zap.default = Zap;
